import React from 'react';
import {ButtonBack, ButtonNext} from "pure-react-carousel";

export default function BioSlide(props) {
    const {
        teamMember,
    } = props;

    return (
      <div className="card bio-card px-3 px-sm-4 px-md-5">
        <ButtonBack className="btn-back"><i className="bi bi-chevron-left"></i></ButtonBack>
        <div className="slider-card">
          <div className="align-items-center row pl-2 pt-3">
            <img alt={`Image of ${teamMember.name}`} className="img" src={teamMember.image_source} />
            <div className="col-md py-3 heading">
              <h3 className="title">{teamMember.name}</h3>
              <h5 className="team-title" dangerouslySetInnerHTML={{ __html: teamMember.job_title }} />
              <a className="btn btn-primary" href={teamMember.linkedin} rel="noreferrer" target="_blank">LinkedIn Profile</a>
            </div>
          </div>
          <div className="body">
            {teamMember.bio_paragraphs.map((paragraph, index) => (
              <p dangerouslySetInnerHTML={{__html: paragraph}} key={index} />
            ))}
          </div>
        </div>
        <ButtonNext className="btn-forward"><i className="bi bi-chevron-right"></i></ButtonNext>
      </div>
    );
}

    import { render } from 'react-dom'                                    
    if (window.reactComponents === undefined) {                           
      window.reactComponents = {}                                         
    }                                                                     
    window.reactComponents.undefined = (function() {                   
    let _args = {}                                                        
                                                                          
    return {                                                              
      init: function (Args) {                                             
        _args = Args                                                      
      },                                                                  
      render: function () {                                               
        const  { id, ...props } = JSON.parse(_args)                       
        render(<undefined {...props}/>, document.getElementById(id))   
      }                                                                   
    }                                                                     
  }())